import { List, ListItem } from '@fs/zion-ui'
import React from 'react'
import { getUser } from '../../../../services/userService'
import { getIdElement } from '../../../../util/StringUtil'

export default function MatchTermsFilteredList({ matchTerms, setMatchTerm, setContactName, ...overlay }) {
  const onTableRowClick = async (matchTerm) => {
    setMatchTerm(matchTerm)
    try {
      const userResponse = await getUser(getIdElement(matchTerm.lastUpdaterCisId), 'cisId')
      setContactName(userResponse.data?.identity?.users[0].contactName)
    } catch (err) {
      setContactName()
    }
    overlay.close()
  }

  return (
    <List>
      {matchTerms.map((matchTerm) => {
        return <ListItem primaryText={matchTerm.term} onClick={() => onTableRowClick(matchTerm)} key={matchTerm.term} />
      })}
    </List>
  )
}
